import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	task__bu__list: 'mw/order/task/bu/list',
	task__bu__del: 'mw/order/task/bu/del',
	task__bu__add: 'mw/order/task/bu/add',
	task__bu__set: 'mw/order/task/bu/set',
};

export const buApi = createApi({
	reducerPath: 'mw/order/task/buApi',

	endpoints: (builder) => ({
		taskBuList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/order/task/bu/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.task__bu__list],
		}),
		taskBuDel: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/order/task/bu/del',
				body,
				jsonType: true,
			}),
			providesTags: [tags.task__bu__del],
		}),
		taskBuAdd: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/order/task/bu/add',
				body,
				jsonType: true,
			}),
			providesTags: [tags.task__bu__add],
		}),
		taskBuSet: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/order/task/bu/set',
				body,
				jsonType: true,
			}),
			providesTags: [tags.task__bu__set],
		}),
	}),
});

export const {
	taskBuList,
	taskBuDel,
	taskBuAdd,
	taskBuSet,
} = buApi.endpoints;

export default buApi;
